<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper :routerLink="'/adjustments'" min="-1" max="1" defaultValue="0" v-model="value.saturation" label="menu.saturation"/>
  </div>
</template>

<script lang="ts">
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Saturation extends FilterMixin {

  protected value = { saturation: 0 };

  protected filter = new Adjustments.Saturation();
}

export default Saturation;
</script>
